export default __webpack_public_path__ + "static/media/1.ed933019.png";